import * as jQuery from 'jquery';
var $ = jQuery;
export function horizontalStatsWidgetScripts() {
    $(document).ready(function () {
        'use strict';
        // Initialize horizontal stats functionality
        function initHorizontalStats() {
            var statsWidget = document.querySelector('.horizontal-stats-widget');
            if (!statsWidget)
                return;
            // Set up intersection observer for scroll-triggered animation
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        animateNumbers(entry.target);
                        observer.unobserve(entry.target); // Only animate once
                    }
                });
            }, {
                threshold: 0.5, // Trigger when 50% of the widget is visible
                rootMargin: '0px 0px -100px 0px' // Start animation slightly before fully in view
            });
            observer.observe(statsWidget);
        }
        // Animate numbers from 0 to target value
        function animateNumbers(widget) {
            var numberElements = widget.querySelectorAll('.stat-number-value');
            numberElements.forEach(function (element) {
                var targetValue = parseInt(element.getAttribute('data-target') || '0');
                var duration = 2000; // 2 seconds
                var startTime = performance.now();
                function updateNumber(currentTime) {
                    var elapsed = currentTime - startTime;
                    var progress = Math.min(elapsed / duration, 1);
                    // Easing function for more linear animation
                    var easeOutQuad = 1 - Math.pow(1 - progress, 2);
                    var currentValue = Math.floor(targetValue * easeOutQuad);
                    element.textContent = currentValue.toString();
                    if (progress < 1) {
                        requestAnimationFrame(updateNumber);
                    }
                    else {
                        element.textContent = targetValue.toString(); // Ensure final value is exact
                    }
                }
                requestAnimationFrame(updateNumber);
            });
        }
        // Initialize when DOM is ready
        initHorizontalStats();
    });
}
